import { render, staticRenderFns } from "./_Delta.vue?vue&type=template&id=07f597ca"
import script from "./_Delta.vue?vue&type=script&lang=js"
export * from "./_Delta.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports